import { Mail, Phone, MapPin, Send, CheckCircle, X } from 'lucide-react';
import { useState, useEffect } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (showPopup) {
      const timer = setTimeout(() => {
        setShowPopup(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [showPopup]);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Form submission logic would go here
    console.log('Form submitted:', formData);
    setShowPopup(true);
    setFormData({ name: '', email: '', message: '' });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <section id="contact" className="py-16 md:py-24 bg-gray-50">
      {showPopup && (
        <div className="fixed bottom-4 right-4 bg-white rounded-lg shadow-2xl border-2 border-yellow-accent z-50 max-w-sm p-4 animate-slide-up">
          <div className="flex items-start justify-between mb-2">
            <div className="flex items-center space-x-2">
              <CheckCircle className="text-yellow-accent" size={20} />
              <h3 className="font-bold text-gray-dark text-sm">Message Sent!</h3>
            </div>
            <button
              onClick={() => setShowPopup(false)}
              className="text-gray-400 hover:text-gray-dark transition-colors"
              aria-label="Close"
            >
              <X size={18} />
            </button>
          </div>
          <p className="text-xs text-gray-light leading-relaxed">
            Thank you for your message! We'll get back to you soon.
          </p>
        </div>
      )}
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-dark text-center mb-12">
            Get in Touch
          </h2>
          
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <p className="text-lg text-gray-light mb-8 leading-relaxed">
                Have a question about a casino? Found an issue with one of our reviews? 
                Want to suggest a new operator? We're here to help. Drop us a line and 
                we'll respond as soon as possible.
              </p>
              
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="bg-yellow-accent p-3 rounded-lg">
                    <Mail className="text-gray-dark" size={24} />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-dark mb-1">Email</h3>
                    <a href="mailto:info@sceptreslots.com" className="text-gray-light hover:text-yellow-accent transition-colors" itemprop="email">
                      info@sceptreslots.com
                    </a>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="bg-yellow-accent p-3 rounded-lg">
                    <Phone className="text-gray-dark" size={24} />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-dark mb-1">Phone</h3>
                    <a href="tel:+448147675497" className="text-gray-light hover:text-yellow-accent transition-colors" itemprop="telephone">
                      +44 8147 675 497
                    </a>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="bg-yellow-accent p-3 rounded-lg">
                    <MapPin className="text-gray-dark" size={24} />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-dark mb-1">Address</h3>
                    <p className="text-gray-light" itemprop="address">London, United Kingdom</p>
                  </div>
                </div>
              </div>
            </div>
            
            <form onSubmit={handleSubmit} className="bg-white p-8 rounded-xl shadow-lg">
              <div className="mb-6">
                <label htmlFor="contact-name" className="block text-gray-dark font-semibold mb-2">
                  Name
                </label>
                <input
                  type="text"
                  id="contact-name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  autoComplete="name"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-accent focus:border-transparent"
                  placeholder="Your name"
                />
              </div>
              
              <div className="mb-6">
                <label htmlFor="contact-email" className="block text-gray-dark font-semibold mb-2">
                  Email
                </label>
                <input
                  type="email"
                  id="contact-email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  autoComplete="email"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-accent focus:border-transparent"
                  placeholder="your.email@example.com"
                />
              </div>
              
              <div className="mb-6">
                <label htmlFor="contact-message" className="block text-gray-dark font-semibold mb-2">
                  Message
                </label>
                <textarea
                  id="contact-message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  autoComplete="off"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-accent focus:border-transparent resize-none"
                  placeholder="Your message..."
                />
              </div>
              
              <button
                type="submit"
                className="w-full bg-yellow-accent text-gray-dark py-3 px-6 rounded-lg font-bold hover:bg-yellow-light transition-colors flex items-center justify-center space-x-2"
              >
                <span>Send Message</span>
                <Send size={20} />
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;

